module.exports = __webpack_public_path__ + "img/food&drink.9d9574c5.svg";